module.exports = __webpack_public_path__ + "static/media/2.a90b0f86.jpg";